import { STORE_ID, TYPES } from "./types";
import store from "../../index";

function dispatch(data) {
    data = { ...data, storeId: STORE_ID }
    store.dispatch(data);
}

export function setPermitions(value) {
    dispatch({
        type: TYPES.SET_PERMITIONS,
        value
    })
}

export function item(value) {
    dispatch({
        type: TYPES.CENTROCUSTO,
        value
    });
}

export function getLojas(value) {
    dispatch({
        type: TYPES.SET_LOJAS,
        value
    });
}

export function getCentrosCusto(value) {
    dispatch({
        type: TYPES.SET_CENTROS_CUSTO,
        value
    });
}

export function copy(value) {
    dispatch({
        type: TYPES.CENTROCUSTO_COPY,
        value
    });
}

export function setInvalid(field) {
    dispatch({
        type: TYPES.INVALID_CENTROCUSTO,
        field
    });
}

export function getItems(value) {
    dispatch({
        type: TYPES.CENTROS,
        value
    });
}

export function cleanInvalid(field) {
    dispatch({
        type: TYPES.CLEAN_INVALID_CENTROCUSTO,
        field
    })
}

export function cleanRegister() {
    dispatch({
        type: TYPES.CLEAN_REGISTER
    })
}

export function setActiveTab(value) {
    dispatch({
        type: TYPES.SET_ACTIVE_TAB,
        value
    })
}

export function setSeeRegister(value) {
    dispatch({
        type: TYPES.SET_SEE,
        value
    })
}

export function setActivePersona(value) {
    dispatch({
        type: TYPES.SET_PERSONA,
        value
    })
}